/** Packages * */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
/** Components * */
import MainCardContainer from '../../components/MainCardContainer/';
import CICard from '../../components/Common/CICard';
import CardHead from '../../components/CardHead';
import CardRow from '../../components/CardRow';
import OpenBidCards from '../../components/OpenBidCards';
import * as actions from './../../data/home/actions';
import * as actionsSettings from './../../data/settings/actions';
import * as utils from '../../utilities/calendarUtilities';
import { LANGUAGE, STAFFID, STDBIDSESSION_ID } from './../../data/constants/';
import Loader from './../../components/Loader';
import { getDateStr, getDateVerbiage } from './../../utilities/helpers';
import * as HomeSetting from './../../settings/settings';
import Dialog from '../../components/Dialog';
import { useLanguage } from '../../context/LanguageContext';

function isEven(n) {
  return n % 2 === 0;
}

const Home = props => {
  const { labels } = useLanguage();
  const cards = labels.cards || {};
  const commonLabels = labels.commonLabels || {};
  const BID_TABLE = labels.BID_TABLE || {};
  const IMPERSONATE_HOME_MESSAGE = labels.IMPERSONATE_HOME_MESSAGE || {};

  const [openNewsModal, setOpenNewsModal] = useState(false)
  const [openNotesModal, setOpenNotesModal] = useState(false)

  const { fetchHome, getLanguage, fetchSettings, home, isFetching, settings, isSettingsFetching } = props;
  const staffId = sessionStorage.getItem(STAFFID);
  const standingBidSessionId = sessionStorage.getItem(STDBIDSESSION_ID);
  const user = home.user ? home.user : {};
  const isAdminLogged = user.staffId === commonLabels.ADMIN;
  const admin = sessionStorage.getItem('admin');
  let messages = home.messages ? home.messages : [];
  const openBids = home.openBids ? home.openBids : {};

  let lang = sessionStorage.getItem(LANGUAGE.LANG_KEY);
  if (!lang) {
    getLanguage(staffId);
    lang = sessionStorage.getItem(LANGUAGE.LANG_KEY);
  }

  const [value, setValue] = useState(lang === LANGUAGE.DEFAULT_LANG ? 1 : 2)

  useEffect(() => {
    fetchHome(staffId);
    fetchSettings(staffId, standingBidSessionId);
  },[])

  const titleStyles = {
    fontSize: '1rem',
    verticalAlign: 'middle',
    paddingTop: '10px'
  };
  const bidTitleStyles = {
    fontSize: '1rem',
    verticalAlign: 'middle',
    paddingTop: '0'
  };
  const formatMessage = (note => note.split(/\r?\n|\r|\n/g).join('<br />'));
  messages =
    messages.length > 0 ? (
      messages.map(message => formatMessage(message.notes))
    ) : (
      <i className='ion ion-ios-partlysunny-outline emptyCard' />
    );
  if (messages.length > 0) {
    messages = ( <div dangerouslySetInnerHTML={{ __html: messages }} /> );
  }
  const notes = user.plannerNote ? (
    <div dangerouslySetInnerHTML={{ __html: formatMessage(user.plannerNote) }} />
  ) : (
    <i className='ion ion-ios-partlysunny-outline emptyCard' />
  );

  // Insert Cards in arrays to CardRow.
  const messageCards = [
    <div 
      onClick={messages?.type === "div" ? () => setOpenNewsModal(true) : null}  
      style={messages?.type === "div" ? { cursor: 'pointer' } : {}}
    >
      <CICard
        title={
          <CardHead
            title={cards.titles.NEWS_AND_MESSAGES}
            titleStyle={titleStyles}
          />
        }
        backgroundColor='#3F51B5'
        titleColor='white'
        cardState={{ shown: 1 }}
        cardContent={messages}
        scrollY
      />
    </div>
    ,
    <div 
      onClick={notes?.type === "div" ? () => setOpenNotesModal(true) : null}
      style={notes?.type === "div" ? { cursor: 'pointer' } : {}}
    >
      <CICard
        title={
          <CardHead
            title={cards.titles.NOTES_FROM_PLANNER}
            titleStyle={titleStyles}
          />
        }
        backgroundColor='#3F51B5'
        titleColor='white'
        cardState={{ shown: 1 }}
        cardContent={notes}
        scrollY
      />
    </div>
  ];

  const openBidRows = [];
  let openBidItems = [];
  if (openBids.entries !== undefined && sessionStorage.getItem(STAFFID) !== commonLabels.ADMIN) {
    openBids.entries.map((entry, index) => {
      const openDate = new Date(entry.openingBidSessionDate);
      const closeDate = new Date(entry.closingBidSessionDate);
      const lastSavedDate = new Date(entry.lastSaved);
      const verbiage = getDateVerbiage(entry.lastSaved);
      let lastSavedDateText = '';
      if (entry.lastSaved) {
        lastSavedDateText = `${
          commonLabels.dates.months[lastSavedDate.getMonth()]
        } ${lastSavedDate.getDate()}${verbiage} ${lastSavedDate.getFullYear()}`;
      } else {
        lastSavedDateText = '--';
      }

      let endDate;
      if (!isAdminLogged) {
        const entryEndDate = new Date(
          entry.endDate[0],
          entry.endDate[1] - 1,
          entry.endDate[2]
        );
        endDate = utils.removeDays(entryEndDate, 1);
      }
      const openBidCardHeadSubtitle = isAdminLogged
        ? ''
        : `${commonLabels.dates.months[entry.startDate[1] - 1]} ${
            entry.startDate[2]
          }, ${entry.startDate[0]} -
          ${
            commonLabels.dates.months[endDate.getMonth()]
          } ${endDate.getDate()}, ${endDate.getFullYear()}`;

      const isOpen = entry.isOpen !== undefined ? entry.isOpen : true;
      const cardBackgroundColor = isOpen ? '#009688' : '#9E9E9E';
      
      const closedBadge = !isOpen ? (
        <div className="closed-badge-home">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="4" y1="12" x2="20" y2="12" transform="rotate(45 12 12)"></line>
          </svg>
          CLOSED
        </div>
      ) : null;
      
      openBidItems.push(
        <CICard
          key={entry.bidSessionId}
          title={
            <CardHead
              title={`${entry.name} Session`}
              titleStyle={bidTitleStyles}
              subtitle={openBidCardHeadSubtitle}
              subtitleClassName='Card-Subtitle'
              rightElement={closedBadge}
            />
          }
          backgroundColor={cardBackgroundColor}
          titleColor='white'
          cardState={{ shown: 1 }}
          cardContent={
            <OpenBidCards
              daysLeft={Number(closeDate.getDay() - openDate.getDay())}
              lastModifiedDate={lastSavedDateText}
              bidSessionId={entry.bidSessionId}
              isOpen={isOpen}
            />
          }
        />
      );
      if (!isEven(index) || index === openBids.entries.length - 1) {
        openBidRows.push(
          <CardRow key={openBidRows.length + 1} cards={openBidItems} />
        );
        openBidItems = [];
      }
      return index;
    });
  }

  let editDefaultsRequestsCard;
  if (settings) {
    const lastRevisionData = settings.lastRevisionData
      ? settings.lastRevisionData
      : {};

    let lastSavedDateText = '';

    if (lastRevisionData.lastSave) {
      const verbiage = getDateVerbiage(lastRevisionData.lastSave);
      const lastSavedDate = new Date(lastRevisionData.lastSave);
      lastSavedDateText = `${
        commonLabels.dates.months[lastSavedDate.getMonth()]
      } ${lastSavedDate.getDate()}${verbiage} ${lastSavedDate.getFullYear()}`;
    } else {
      lastSavedDateText = '--';
    }

    editDefaultsRequestsCard = [
      <CICard
        title={
          <CardHead
            title={BID_TABLE.STANDING_BIDS.CARD_TITLE}
            titleStyle={bidTitleStyles}
            subtitleClassName={'Card-Subtitle-Black'}
            subtitle={BID_TABLE.STANDING_BIDS.CARD_SUBTITLE}
          />
        }
        backgroundColor='#74E496'
        titleColor='black'
        cardState={{ shown: 1 }}
        key={'editDefaultsRequestsCard'}
        cardContent={
          <OpenBidCards
            daysLeft={0}
            lastModifiedDate={lastSavedDateText}
            bidSessionId={standingBidSessionId}
            defaultSettingsEdit
          />
        }
      />
    ];
    if (sessionStorage.getItem(STAFFID) === commonLabels.ADMIN) {
      editDefaultsRequestsCard = [];
    }
  }

  return (
    <div>
      {isFetching || isSettingsFetching ? (
        <Loader />
      ) : (
        <MainCardContainer
          headTitle={commonLabels.WELCOME + user.name}
          headSubtitle={
            admin === commonLabels.ADMIN
              ? commonLabels.ADMIN_LABEL
              : HomeSetting.home.displayLastVisit
              ? commonLabels.LAST_VISITED +
                getDateStr(user.crewInterfaceLastUse)
              : ''
          }
          content={[
            <CardRow key={0} cardNumber={2} cards={messageCards} />,
            <CardRow
              key={1}
              cardNumber={2}
              cards={editDefaultsRequestsCard}
            />,
            openBidRows
          ]}
        />
      )}
      <Dialog 
        openDialog={openNewsModal}
        handleOpen={() => setOpenNewsModal(false)}
        dialogTitle={cards.titles.NEWS_AND_MESSAGES}
        dialogMessage={messages}
      />
      <Dialog 
        openDialog={openNotesModal}
        handleOpen={() => setOpenNotesModal(false)}
        dialogTitle={cards.titles.NOTES_FROM_PLANNER}
        dialogMessage={notes}
      />
    </div>
  );
}

Home.defaultProps = {
  getLanguage: () => {},
  fetchHome: function fetchHome() {},
  home: {
    user: {},
    messages: [],
    openBids: {}
  },
  isFetching: true,
  isSettingsFetching: true,
  fetchSettings: function fetchSettings() {}
};

Home.propTypes = {
  fetchHome: PropTypes.func.isRequired,
  getLanguage: PropTypes.func,
  home: PropTypes.shape({
    user: PropTypes.object,
    messages: PropTypes.array,
    openBids: PropTypes.object
  }),
  isFetching: PropTypes.bool,
  isSettingsFetching: PropTypes.bool,
  fetchSettings: PropTypes.func.isRequired,
  settings: PropTypes.shape({
    lastRevisionData: PropTypes.object
  })
};

const mapStateToProps = state => ({ ...state.home, ...state.settings });

const mapDispatchToProps = dispatch => ({
  fetchHome: staffId => dispatch(actions.default.fetchHome(staffId)),
  getLanguage: staffId => dispatch(actions.default.getLanguage(staffId)),
  fetchSettings: (staffId, standingBidSessionId) =>
    dispatch(actionsSettings.fetchSettings(staffId, standingBidSessionId))
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
